import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "group-wrapper" }
const _hoisted_2 = { class: "group-title" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import { switchGroupReq } from '@/services/micro-app-cache'


const __default__ = {
  name: 'GroupPicker'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()

const groups = computed(() => store.getters['microAppCache/getUserGroups'] ?? [])
const selectedGroup = computed(() => store.getters['microAppCache/getSelectedGroup'])
const selectedGroupId = computed(() => selectedGroup.value?.groupId ?? null)
const selectedGroupName = computed(() => selectedGroup.value?.groupName ?? '')

const handleSwitchGroup = (groupId: number) => {
  switchGroupReq(groupId).then(() => location.reload())
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (groups.value.length > 1)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        onCommand: handleSwitchGroup,
        "popper-class": "group-dropdown",
        trigger: "click",
        size: "default"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: item.groupId,
                  command: item.groupId,
                  disabled: item.groupId === selectedGroupId.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.groupName), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "disabled"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(selectedGroupName.value), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "arrow-down" }, null, -1))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})